// extracted by mini-css-extract-plugin
module.exports = {"news":"news-1p0wE7bI"};